<template>
  <div class="app-container-v2 table-container-v2">
    <div class="title-box">
      <div class="title-left">
        <span class="title-text">企业信息</span>
      </div>
      <div class="title-right">
        <el-button type="primary" class="button-v2" @click="handleAdd">+ 添加企业信息</el-button>
      </div>
    </div>

    <div class="table-body flex vertical" v-loading="loading">
      <air-table
          ref="airTable"
          class="table-v2"
          :show-checkbox="false"
          align="center"
          :columns="columns"
          :data="tableData"
          @change-filter="changeFilter"
      >
        <template #operation="{ row }">
          <div class="flex center mt4">
            <span class="text-button" @click="handleEdit(row)">编辑</span>
            <div class="divider ml10 mr10"></div>
            <span class="text-button" @click="handleDelete(row)">删除</span>
          </div>
        </template>
      </air-table>

      <vxe-pager
          class="pager-v2"
          background
          :current-page.sync="queryParams.page"
          :page-size.sync="queryParams.limit"
          :total="total"
          :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'Sizes', 'Total']"
          @page-change="getData"
      ></vxe-pager>
    </div>

    <el-dialog class="modal-v2" :title="companyModal.title" :visible.sync="companyModal.show" :close-on-click-modal="false" width="700px" append-to-body>
      <div class="flex vertical">
        <el-form ref="form" class="form-v2 report-form" :model="form" :rules="formRules" label-width="160px" style="margin: 40px 0; padding: 0 30px;">
          <el-form-item label="企业名称：" prop="companyName">
            <el-input v-model="form.companyName" class="input-v2" placeholder="请输入企业名称" maxlength="100" />
          </el-form-item>
          <el-form-item label="统一社会信用代码：" prop="companyNum">
            <el-input v-model="form.companyNum" class="input-v2" placeholder="请输入统一社会信用代码" maxlength="30" />
          </el-form-item>
          <el-form-item label="组织机构代码：" prop="companyCode">
            <el-input v-model="form.companyCode" class="input-v2" placeholder="请输入组织机构代码" maxlength="30" />
          </el-form-item>
          <el-form-item label="企业负责人：" prop="managerName">
            <el-input v-model="form.managerName" class="input-v2" placeholder="请输入企业负责人" maxlength="20" />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="w100 flex jbetween acenter">
        <el-button plain class="button-v2" @click="companyModal.show = false">取消</el-button>
        <el-button type="primary" class="button-v2" :loading="submitLoading" @click="handleSave">保存</el-button>
      </div>
    </el-dialog>

    <air-confirm-v2
        :show.sync="confirmShow"
        :title="confirmTitle"
        :content="confirmContent"
        :confirm-function="confirmFunction"
    ></air-confirm-v2>

    <paid-modal :show.sync="paidModalShow"></paid-modal>
  </div>
</template>

<script>
import * as api from '@/api/v2/sishang/company'
import PaidModal from '../report/components/PaidModal/index.vue'

export default {
  name: 'SishangCompany',
  components: {
    PaidModal
  },
  data() {
    return {
      loading: true,
      queryParams: {
        page: 1,
        limit: 20,
      },
      total: 0,
      columns: [
        {title: '企业名称', field: 'companyName', minWidth: 150, filterType: 'input'},
        {title: '统一社会信用代码', field: 'companyNum', minWidth: 150, filterType: 'input'},
        {title: '组织机构代码', field: 'companyCode', minWidth: 150, filterType: 'input'},
        {title: '企业负责人', field: 'managerName', minWidth: 100, filterType: 'input'},
      ],
      tableData: [],
      form: {},
      formRules: {
        companyName: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
        managerName: [{ required: true, message: '请输入企业负责人', trigger: 'blur' }],
      },
      companyModal: {
        show: false,
        title: '添加企业信息',
        edit: false
      },
      submitLoading: false,
      confirmShow: false,
      confirmTitle: '',
      confirmContent: '',
      confirmFunction: undefined,
      paidModalShow: false
    }
  },
  computed: {
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getData()
    },
    getData() {
      this.loading = true
      api.selectSuperviseReportCompanyByPage(this.queryParams).then(res => {
        this.tableData = res.data.data.records
        this.total = res.data.data.total
        this.loading = false
      })
    },
    changeFilter(e) {
      this.queryParams = {...this.queryParams, ...e.filterData}
      this.getData()
    },
    reset() {
      this.form = {
        companyName: '',
        companyCode: '',
        companyNum: '',
        managerName: ''
      }
    },
    handleAdd() {
      this.reset()
      this.companyModal.title = '添加企业信息'
      this.companyModal.edit = false
      this.companyModal.show = true
    },
    handleEdit(item) {
      this.form = {
        id: item.id,
        companyName: item.companyName,
        companyCode: item.companyCode,
        companyNum: item.companyNum,
        managerName: item.managerName
      }
      this.companyModal.title = '编辑企业信息'
      this.companyModal.edit = true
      this.companyModal.show = true
    },
    handleSave() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (!this.form.companyCode && !this.form.companyNum) {
            this.$msgError('统一社会信用代码或组织机构代码二者必填其一')
            return
          }
          this.submitLoading = true
          let companyApi = this.companyModal.edit ? api.updateSuperviseReportCompany : api.addSuperviseReportCompany
          companyApi(this.form).then(res => {
            if (res.data.code === 0) {
              this.$msgSuccess('保存成功')
              this.getData()
              this.companyModal.show = false
            }
          }).finally(() => this.submitLoading = false)
        }
      })
    },
    handleDelete(item) {
      this.confirmShow = true
      this.confirmTitle = '删除企业'
      this.confirmContent = `确认删除企业「${item.companyName}」?`
      this.confirmFunction = () => {
        api.deleteSuperviseReportCompany(item.id).then(() => {
          this.getData()
          this.$msgSuccess('删除成功')
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/air/assets/css/main.scss";
</style>
